import React, { useState } from 'react';
import shortid from 'shortid';
import Renderer from '../Renderer';

const DefaultFormatDataLink = ({
  schema,
  data,
  path,
  ownData,
  ownDefinitions,
  ownProps = {},
}) => {
  const { onClick = () => Promise.resolve() } = ownProps;
  const [fetching, setFetching] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  if (response && !error) {
    const children = [
      ...(Array.isArray(response)
        ? response
        : typeof response === 'object'
          ? [response]
          : []),
    ];

    return children.map(child => (
      <Renderer
        key={shortid.generate()}
        data={child.data}
        displaySchema={child.display_schema}
        definitions={ownDefinitions}
        path={path}
        isChildRoot
      />
    ));
  }

  const handleCallback = async () => {
    setFetching(true);
    try {
      const result = await onClick({ data: ownData, schema });
      setResponse(result);
    } catch (error) {
      setError(error);
    } finally {
      setFetching(false);
    }
  };

  return (
    <div className={`default-type-string depth-${path.length}`}>
      <strong className="default-type-string-title">{schema.title}</strong>{' '}
      <div>
        <button
          className="default-format-data-link-button"
          disabled={fetching}
          onClick={handleCallback}
        >
          {fetching ? 'Loading...' : data}
        </button>
        {error && !fetching && (
          <span className="default-format-data-link-error">
            Failed to retrieve data. Please try again.
          </span>
        )}
      </div>
    </div>
  );
};

export default DefaultFormatDataLink;
